module.exports = __webpack_public_path__ + "img/106.09b51c2c.png";